module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": _vm.flat
    }
  }, [_c('v-snackbar', {
    model: {
      value: (_vm.successsnacker),
      callback: function($$v) {
        _vm.successsnacker = $$v
      },
      expression: "successsnacker"
    }
  }), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-btn', {
    staticClass: "blue",
    attrs: {
      "absolute": "",
      "dark": "",
      "fab": "",
      "top": "",
      "right": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.editmode = "add";
        _vm.setBlankSelectedRow();
        _vm.addedit = true;
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _vm._t("before-table", null, {
    "selected": _vm.selected
  }), _vm._v(" "), _c('v-data-table', {
    class: {
      'dense': _vm.dense
    },
    attrs: {
      "dense": "",
      "loading": _vm.loading,
      "headers": _vm.tableHeaders,
      "items": _vm.tableItems,
      "hide-actions": true,
      "disable-initial-sort": true
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "grey lighten-2"
        }, [(_vm.selectable) ? _c('th', {
          staticStyle: {
            "max-width": "5px"
          }
        }, [_c('v-checkbox', {
          staticClass: "mt-4",
          model: {
            value: (_vm.selectAll),
            callback: function($$v) {
              _vm.selectAll = $$v
            },
            expression: "selectAll"
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.withExpand) ? _c('th', {
          staticStyle: {
            "max-width": "50px"
          }
        }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), _vm._l((props.headers), function(header) {
          return _c('th', {
            key: header.text,
            staticClass: "overline",
            staticStyle: {
              "text-align": "left"
            }
          }, [_vm._t(("header-" + (header.value)), function() {
            return [_vm._v(_vm._s(header.text))]
          })], 2)
        }), _vm._v(" "), _c('th', {
          staticStyle: {
            "max-width": "50px"
          }
        }, [_vm._v(" ")])], 2), _vm._v(" "), _c('v-divider')]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: {
            "archived": props.item.archived
          },
          on: {
            "click": function($event) {
              _vm.editmode = "edit";
              _vm.selectedRow = props.item;
              _vm.addedit = true
            }
          }
        }, [(_vm.withExpand) ? _c('td', {
          staticStyle: {
            "max-width": "50px"
          }
        }, [_c('v-btn', {
          attrs: {
            "small": "",
            "flat": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [(!props.expanded) ? _c('v-icon', [_vm._v("expand_more")]) : _c('v-icon', [_vm._v("expand_less")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectable) ? _c('td', [_c('div', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.noop.apply(null, arguments)
            }
          }
        }, [_c('v-checkbox', {
          attrs: {
            "small": "",
            "value": props.item
          },
          model: {
            value: (_vm.selected),
            callback: function($$v) {
              _vm.selected = $$v
            },
            expression: "selected"
          }
        })], 1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.tableHeaders), function(header) {
          return _c('td', {
            key: header.value
          }, [_vm._t(header.value, function() {
            return [(header.component === "vcheckbox") ? [(props.item[header.value]) ? _c('v-icon', {
              attrs: {
                "small": ""
              }
            }, [_vm._v("check_box")]) : _c('v-icon', {
              attrs: {
                "small": ""
              }
            }, [_vm._v("check_box_outline_blank")])] : _c('span', [_vm._v(_vm._s(props.item[header.value]))])]
          }, {
            "value": props.item[header.value],
            "item": props.item
          })], 2)
        }), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('v-btn', {
          attrs: {
            "small": "",
            "icon": "",
            "outline": "",
            "outlined": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), (_vm.withInlineDelete) ? _c('v-btn', {
          attrs: {
            "small": "",
            "icon": "",
            "outline": "",
            "outlined": "",
            "color": "error"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.selectedRow = props.item;
              _vm.confirmDelete = true
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("delete")])], 1) : _vm._e()], 1)], 2), _vm._v(" "), (props.item.loading) ? _c('tr', [_c('td', {
          staticStyle: {
            "padding": "0px",
            "height": "4px"
          },
          attrs: {
            "colspan": "100%"
          }
        }, [_c('v-progress-linear', {
          staticStyle: {
            "margin": "0px",
            "padding": "0px"
          },
          attrs: {
            "height": 3,
            "indeterminate": true
          }
        })], 1)]) : _vm._e()]
      }
    }, {
      key: "expand",
      fn: function(props) {
        return [_vm._t("expand", null, {
          "item": props.item
        })]
      }
    }], null, true)
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "no-data"
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n          " + _vm._s(_vm.noDataText) + "\n          "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.editmode = "add";
        _vm.setBlankSelectedRow();
        _vm.addedit = true;
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.emptyBtnText))])], 1) : _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    staticClass: "mr-1",
    attrs: {
      "color": "amber",
      "width": "1",
      "size": "14",
      "indeterminate": ""
    }
  }), _vm._v(" loading\n        ")], 1)])], 2), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": (_vm.dialogWidth - 30)
    },
    model: {
      value: (_vm.confirmDelete),
      callback: function($$v) {
        _vm.confirmDelete = $$v
      },
      expression: "confirmDelete"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "subheading py-0"
  }, [_vm._v("\n            " + _vm._s(_vm.confirmDeleteTitle) + "\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.confirmDelete = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.successsnacker && _vm.deleteRequestStatus === 204) ? _c('v-alert', {
    staticClass: "ma-0 absolute-top",
    attrs: {
      "absolute": "",
      "dismissible": "",
      "transition": "slide-y-transition",
      "type": "success",
      "value": true
    }
  }, [_vm._v("\n            Your changes have been saved\n        ")]) : _vm._e(), _vm._v(" "), _c('v-card-text', [(_vm.confirmDeleteTagline) ? _c('v-alert', {
    staticClass: "subheading",
    attrs: {
      "type": "info",
      "value": true,
      "dense": ""
    }
  }, [_vm._v("\n            " + _vm._s(_vm.confirmDeleteTagline) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.headers), function(header, index) {
    return [_c('v-list-tile', {
      key: header.index
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.selectedRow[header.value]))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(header.value))])], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: index
    })]
  })], 2)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.confirmDelete = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "color": "error"
    },
    on: {
      "click": _vm.deleteRow
    }
  }, [_vm._v(_vm._s(_vm.deleteText))])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": _vm.dialogWidth
    },
    model: {
      value: (_vm.addedit),
      callback: function($$v) {
        _vm.addedit = $$v
      },
      expression: "addedit"
    }
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.isValid),
      callback: function($$v) {
        _vm.isValid = $$v
      },
      expression: "isValid"
    }
  }, [_c('v-card', [(_vm.withInlineHelp) ? _c('v-navigation-drawer', {
    attrs: {
      "permanent": "",
      "absolute": "",
      "right": "",
      "value": true
    }
  }, [_vm._v("\n          Help information will show here\n        ")]) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "subheading py-0 grey lighten-4"
  }, [(_vm.editmode == "edit") ? _c('span', [_vm._v("Edit")]) : _c('span', [_vm._v("Add")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.$emit("crud:adddialogclosed");
        _vm.addedit = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.editRequestStatus === 400 || _vm.createRequestStatus === 0) ? _c('v-alert', {
    staticClass: "ma-0 absolute-top",
    attrs: {
      "transition": "slide-y-transition",
      "absolute": "",
      "dismissible": "",
      "type": "warning",
      "value": true
    }
  }, [_vm._v("\n            Some information you entered was invalid. Please check below and resubmit\n        ")]) : _vm._e(), _vm._v(" "), (_vm.successsnacker && (_vm.editRequestStatus === 200 || _vm.createRequestStatus === 201)) ? _c('v-alert', {
    staticClass: "ma-0 absolute-top",
    attrs: {
      "absolute": "",
      "dismissible": "",
      "transition": "slide-y-transition",
      "type": "success",
      "value": true
    }
  }, [_vm._v("\n            Your changes have been saved\n        ")]) : _vm._e(), _vm._v(" "), _vm._t("addedit-cardtext-outer"), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._t("dialog-header"), _vm._v(" "), _vm._l((_vm.headers), function(header, key) {
    return [_vm._t("field-" + header.value, function() {
      return [_c('v-flex', _vm._b({
        staticClass: "px-2",
        attrs: {
          "xs12": !header.flex
        }
      }, 'v-flex', header.flex, false), [(header.component === "vcheckbox") ? _c('v-checkbox', {
        staticClass: "mb-3",
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "error-messages": _vm.getErrors(header.value),
          "hint": header.hint,
          "label": header.text,
          "prefix": header.prefix,
          "suffix": header.suffix,
          "required": header.required,
          "rules": header.rules || [],
          "type": header.type || "text",
          "persistent-hint": ""
        },
        model: {
          value: (_vm.selectedRow[header.value]),
          callback: function($$v) {
            _vm.$set(_vm.selectedRow, header.value, $$v)
          },
          expression: "selectedRow[header.value]"
        }
      }) : (header.component === "vdivider") ? _c('v-divider', {
        staticClass: "my-3"
      }) : (header.component === "vselect") ? _c('v-select', _vm._b({
        staticClass: "mb-3",
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "error-messages": _vm.getErrors(header.value),
          "hint": header.hint,
          "label": header.text,
          "prefix": header.prefix,
          "suffix": header.suffix,
          "required": header.required,
          "rules": header.rules || [],
          "persistent-hint": ""
        },
        model: {
          value: (_vm.selectedRow[header.value]),
          callback: function($$v) {
            _vm.$set(_vm.selectedRow, header.value, $$v)
          },
          expression: "selectedRow[header.value]"
        }
      }, 'v-select', header.attrs, false)) : (header.component) ? _c(header.component, _vm._b({
        tag: "component",
        attrs: {
          "error-messages": _vm.getErrors(header.value)
        },
        model: {
          value: (_vm.selectedRow[header.value]),
          callback: function($$v) {
            _vm.$set(_vm.selectedRow, header.value, $$v)
          },
          expression: "selectedRow[header.value]"
        }
      }, 'component', header.attrs, false)) : _c('v-text-field', _vm._b({
        attrs: {
          "outline": _vm.getErrors(header.value).length > 0,
          "error-messages": _vm.getErrors(header.value),
          "hint": header.hint,
          "label": header.text,
          "prefix": header.prefix,
          "suffix": header.suffix,
          "required": header.required,
          "rules": header.rules || [],
          "type": header.type || "text"
        },
        model: {
          value: (_vm.selectedRow[header.value]),
          callback: function($$v) {
            _vm.$set(_vm.selectedRow, header.value, $$v)
          },
          expression: "selectedRow[header.value]"
        }
      }, 'v-text-field', header.attrs, false))], 1)]
    }, {
      "header": header,
      "selectedRow": _vm.selectedRow
    })]
  })], 2)], 1), _vm._v(" "), (_vm.editmode === "edit") ? _c('v-card-actions', {
    attrs: {
      "absolute": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.selectedRow.id,
      "color": "error"
    },
    on: {
      "click": function($event) {
        _vm.confirmDelete = true
      }
    }
  }, [_vm._v(_vm._s(_vm.deleteText))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.editmode === "edit") ? _c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.addedit = false
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), (_vm.editmode === "edit") ? _c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.editRow
    }
  }, [_vm._v("Save")]) : _vm._e()], 1) : _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.addedit = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.addRow(true)
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), (_vm.closeOnEdit) ? _c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.addRow(false)
      }
    }
  }, [_vm._v("Add & add more")]) : _vm._e()], 1)], 2)], 1)], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-163f5881","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CrudTable.vue
// module id = 1337
// module chunks = 9